<template>
	<div>
		<div class="list-btn">
			<Button type="primary" @click="ret">返回</Button>
		</div>
		<div class="list-btn">
			<RadioGroup v-model="animal">
				<Radio label="列表"></Radio>
				<Radio label="地图"></Radio>
			</RadioGroup>
		</div>
		<div  class="lb" v-if="animal=='列表'">
			<Table border :columns="columns12" :data="data6" :loading="loading">
				<template slot-scope="{ row }" slot="name">
					<strong>{{ row.name }}</strong>
				</template>
				<template slot-scope="{ row, index }" slot="action">
					<Button type="primary" size="small" style="margin-right: 5px" @click="details(row.macDetailsId)">设备信息</Button>
				</template>
			</Table>
			<div class="my-page">
				<page :total="total" @updatePage="updatePage" @updateSize="updateSize"></page>
			</div>
		</div>
		<div class="ditu" v-else>
			<ditu :zxd="zxd" :qt="qt" ></ditu>
		</div>
	</div>
</template>
<script>
	import http from '@/http/http.js'
	import page from '@/components/comm/page.vue'
	import ditu from '@/components/comm/ditu/ditu.vue'
	export default {
		data() {
			return {
				animal: '列表',
				//地图
				zxd: [106.49275526969987, 29.61166095192132], //中心点坐标
				qt: [
					/* {position: [121.5263285, 31.21415044],id:1,url:'alliance/mac/aisle/list',address:'测试地址',code:'s-12'},
					{position: [121.5273285, 31.29415044],id:1,url:'alliance/mac/aisle/list',address:'测试地址',code:'s-12'} */
				],
				//地图
				loading:false,
				total:100,
				columns12: [{
						title: 'id',
						key: 'id'
					},
					{
						title: '设备详情编号',
						key: 'macDetailsCode'
					},
					{
						title: '合同编号',
						key: 'contractCode'
					},
					{
						title: '数量',
						key: 'number'
					},
					{
						title: '已安装数量',
						key: 'installNumber'
					},
					{
						title: '单价',
						key: 'unitPrice'
					},
					{
						title: '操作',
						slot: 'action',
						width: 150,
						align: 'center'
					}
				],
				data6: [
					{
						/* id: '1',
						name: '饮料',
						state: '启用',
						createdTime: '2010-10-10',
						cz: '' */
					}
				],
				query:{
					page:0,
					size:10,
					orderId:''
				}

			}
		},
		methods: {
			ret() { //返回上一页
				this.$router.go(-1)
			},
			updatePage(page) { //页码改变的回调，返回改变后的页码
				this.query.page = page - 1
				this.ajaxPage()
			},
			updateSize(size) { //切换每页条数时的回调，返回切换后的每页条数
				this.query.size = size
				this.ajaxPage()
			},
			details(macDetailsId) {
				let _this=this
				this.$router.push({
					name: 'jm/facility/macOrder/mac/list',
					query:{orderId:_this.query.orderId,macDetailsId:macDetailsId}
				})
			},
			ajaxPage() {
				this.loading = true
				let _this=this
				http.http({
				    //这里是你自己的请求方式、url和data参数
				    method: 'post',
				    url: http.url + '/fin/report/contract/details/page',
				    data: _this.query,
					_this: _this,
					success: function(data) {
						_this.total = data.page.totalElements
						_this.data6 = data.page.content
						_this.loading = false
					}
				    //假设后台需要的是表单数据这里你就可以更改
				  })
				
			}
		},
	    components: {
	    	page,ditu
	    },
		created(){
			let orderId=this.$route.query.orderId;
			
			this.query.orderId=orderId
			this.ajaxPage()
		}
	}
</script>
<style scoped="scoped">
	.list-btn {
		margin-bottom: 20px;
	}

	.delete {
		/* background-color: red;
		color: #333333; */
	}
	.my-page{
		display: flex;
		justify-content: flex-end;
		margin-top: 20px;
	}
</style>



// WEBPACK FOOTER //
// src/components/jm/facility/macOrder/details/list.vue